import { useState, useRef, useEffect } from 'react';

interface Props {
    onClose: () => void;
    onSubmit: (name: string) => Promise<void>;
}

const CreateFolderModal = ({ onClose, onSubmit }: Props) => {
    const [name, setName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus({ preventScroll: true });
        }
    }, []);

    const handleSubmit = async (e?: React.FormEvent) => {
        if (e) e.preventDefault();
        if (!name.trim()) return;

        setIsLoading(true);
        try {
            await onSubmit(name.trim());
            onClose();
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal card modal-sm modal-premium" onClick={(e) => e.stopPropagation()}>
                <button type="button" className="close-btn" onClick={onClose}>✕</button>

                <div className="modal-content-wrapper">
                    <form onSubmit={handleSubmit}>
                        <h2>Nouveau dossier</h2>

                        <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <label className="input-label" htmlFor="folder-name" style={{ fontWeight: 500, color: 'var(--text)' }}>
                                Nom du dossier
                            </label>
                            <input
                                ref={inputRef}
                                id="folder-name"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Ex: Marketing, Projets, Newsletter..."
                                className="input-premium"
                                disabled={isLoading}
                                maxLength={50}
                            />
                        </div>

                        <div className="modal-actions">
                            <button
                                type="button"
                                className="ghost-button"
                                onClick={onClose}
                                disabled={isLoading}
                            >
                                Annuler
                            </button>
                            <button
                                type="submit"
                                className="primary"
                                disabled={!name.trim() || isLoading}
                            >
                                {isLoading ? 'Création...' : 'Créer le dossier'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateFolderModal;
